module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "赠送礼品卡",
      "visible": _vm.dialogVisible,
      "width": "40%",
      "close-on-click-modal": false,
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "formInfo",
    attrs: {
      "model": _vm.formInfo,
      "rules": _vm.formRules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员",
      "prop": "subscriberId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "支持手机号与昵称模糊搜索",
      "remote-method": _vm.loadMemberUsers,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.formInfo.subscriberId),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "subscriberId", $$v)
      },
      expression: "formInfo.subscriberId"
    }
  }, _vm._l((_vm.memberUsers), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.nickname + '（' + item.phoneNo + '）',
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "祝福语",
      "prop": "blessingWord"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入祝福语",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "maxlength": "255"
    },
    model: {
      value: (_vm.formInfo.blessingWord),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "blessingWord", $$v)
      },
      expression: "formInfo.blessingWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "购买价格",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.price),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "price", $$v)
      },
      expression: "formInfo.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面值"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.giftCardRecordInfo.amount),
      callback: function($$v) {
        _vm.$set(_vm.giftCardRecordInfo, "amount", $$v)
      },
      expression: "giftCardRecordInfo.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "购买时间",
      "prop": "buyTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formInfo.buyTime),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "buyTime", $$v)
      },
      expression: "formInfo.buyTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "maxlength": "255"
    },
    model: {
      value: (_vm.formInfo.remark),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "remark", $$v)
      },
      expression: "formInfo.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleGive
    }
  }, [_vm._v("赠送")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-fdb16b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/giftCard/components/giveGiftCard.vue
// module id = 1766
// module chunks = 0